import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

import { useHistory } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { addToRecent } from "utils/builder/IModelsTree";
import { useDashboardState } from "components/DashboardContext";
import "./VersionsModal.scss";

import VersionsItem from "components/uiComponents/VersionsItem";
import UniversalButton from "components/uiComponents/UniversalButton";
import { clearSettingViewer } from "../../../store/actions/template";

const VersionsModal = ({
  versions,
  parentItem,
  title,
  closeModal,
  fileIconPath,
}) => {
  const { t } = useTranslation();

  const history = useHistory();
  const [activeVersion, setActiveVersion] = useState(null);
  const dispatch = useDispatch();

  const {
    setActiveProject,
  } = useDashboardState();

  const handleLoad = (e) => {
    e.preventDefault();

    dispatch(clearSettingViewer());
    addToRecent(parentItem);
    setActiveProject(activeVersion);

    history.push({
      pathname: `/project/${activeVersion.idToOpen}`,
      state: { project: activeVersion }
    });

    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  return (
    <div className="versions-modal">
      <h2>{t('version_history')}</h2>

      <h3>{title}</h3>

      <div className="versions-modal__versions_container">
        {versions && Array.isArray(versions) &&
          versions?.map(item => {
            const handleItemClick = () => {
              setActiveVersion(item);
            };

            return (
              <VersionsItem
                {...item}
                key={item.id}
                onClick={handleItemClick}
                isActive={item.id === activeVersion?.id}
                fileIconPath={fileIconPath}
              />
            );
          })
        }
      </div>

      <div className="versions-modal__btns">
        <div className="versions-modal__btns_btn">
          <UniversalButton
            type="button"
            label={t('close')}
            size="lg"
            labelColor="blue"
            labelHoverColor="blue"
            backgroundColor="white"
            backgroundHoverColor="blue-light"
            onClick={handleCancel}
          />
        </div>

        <UniversalButton
          type="button"
          label={t('load')}
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          isDisabled={!activeVersion}
          onClick={handleLoad}
        />
      </div>
    </div>
  );
};

export default VersionsModal;
